export const deleteProps = (obj, props) => {
    let newObj = Object.assign({}, obj);
    props.forEach((e) => delete newObj[e]);
    return newObj;
};
export const deleteEmptyProps = (obj) => Object.entries(obj).reduce((a, [k, v]) => ([null, undefined, ""].includes(v) ? a : ((a[k] = v), a)), {});
export const getActiveFilterNumber = (obj) => Object.keys(obj).length;
export const getPrintColumns = (tableCols) => tableCols.reduce((arr, col) => (col.hidden || col.unavailable ? arr : arr.concat(col.id)), []);
export const getVisibleColumnsIds = (tableCols, isPrint) => tableCols.reduce((arr, col) => col.hidden ||
    col.unavailable ||
    (isPrint && ["select", "icons", "actions"].includes(col.id))
    ? arr
    : arr.concat(col.id), []);
